const PERFORMANCE_DETAILS_PAGE = {
  title: 'Detalhe de desempenho',
  schedule: { desk: 'Horário', mobile: 'Hor.' },
  consolidated: { desk: 'Consolidado', mobile: 'Cons.' },
  tableTitle: 'Visão por dia/hora',
  goal: 'Meta',
  errors: {
    VAL_0004:
      'Não foi possível exibir os detalhes deste período. Selecione uma semana dentre os últimos 20 dias.',
    REQ_0002:
      'Não foi possível exibir as informações devido a uma instabilidade técnica.',
  },
}

export default PERFORMANCE_DETAILS_PAGE
